var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.336 12.969h-.834v-.827h.834v.827Zm4.17 1.654h-.834v-2.481h.834v2.481Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 6.766a1.56 1.56 0 0 0-.17.708c0 .46.175.872.482 1.184.315.305.73.478 1.17.478h.837v.83c0 .348.11.67.298.935h-.86a.834.834 0 0 0-.834.828v3.515c0 .34.284.62.626.62a.628.628 0 0 0 .626-.62V14.21h.625a.628.628 0 0 0 .626-.62.629.629 0 0 0-.626-.621h-.625v-.827h.625a.628.628 0 0 0 .626-.62v-.011c.168.059.349.092.537.094.26 0 .498-.062.714-.163v6.904c0 .91-.751 1.654-1.668 1.654H5.668A1.666 1.666 0 0 1 4 18.346V8.42c0-.91.75-1.654 1.668-1.654h7ZM6.085 10.9a.833.833 0 0 0-.834.828v3.515c0 .34.284.62.626.62a.628.628 0 0 0 .625-.62V14.21h.834c.692 0 1.25-.555 1.25-1.241v-.827c0-.687-.558-1.24-1.25-1.24H6.085Zm3.753 0a.411.411 0 0 0-.417.414v4.135c0 .232.184.414.417.414h1.668c.692 0 1.25-.554 1.25-1.241v-2.481c0-.687-.558-1.24-1.25-1.24H9.838Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.697 4c.448 0 .814.362.814.807v1.662h1.675c.448 0 .814.362.814.806v.034a.811.811 0 0 1-.814.806h-1.675V9.77a.812.812 0 0 1-.814.806h-.025a.808.808 0 0 1-.821-.806V8.115h-1.668a.815.815 0 0 1-.822-.814v-.026a.824.824 0 0 1 .822-.806h1.668V4.807c0-.445.365-.807.82-.807h.026Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_pdf.5b66d2b0099643fc0a8a1dd7095511c4.svg";